// extracted by mini-css-extract-plugin
export var growableInput = "_79-0";
export var tagContainer = "_79-2";
export var textInput = "_79-1";